import DatePicker from "react-datepicker";
import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import Buttons from "./Controls/Buttons/Button";
import "../components/Controls/DateRange/basicDateRangePicker.scss";
import "./dateRangePickerAdmin.scss";

export default function DateRangePicker({ filterByDate, clear }) {
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [status, setStatus] = React.useState("");

  useEffect(() => {
    if (clear) {
      setDateRange([null, null]);
    }
  }, [clear]);
  return (
    <>
      <Grid
        container
        spacing={1}
        className="BasicDatePiker-wrap adminDatepiker"
        justifyContent="flex-start"
      >
        <Grid item md={8}>
          <DatePicker
            className="DateRangePickerAdministrator"
            placeholderText="MM/DD/YYYY  To  MM/DD/YYYY"
            selectsRange={true}
            startDate={startDate}
            endDate={endDate}
            dateFormat="dd-MMM-yyyy"
            onChange={(update) => {
              setDateRange(update);
            }}
            isClearable={true}
            maxDate={new Date()}
          />
        </Grid>
        <Grid item className="admin-search" md={3}>
          <Buttons
            className="btn-search"
            text="Search"
            size="small"
            onClick={(e) => filterByDate(startDate, endDate, status)}
          />
        </Grid>
      </Grid>
    </>
  );
}
